import type { UseFormRegister } from "react-hook-form";
import { t } from "ttag";

import type { DateOfBirthValues } from "@/shared/models/legacy-types";
import { Input } from "@/shared/ui";
import { CalendarIcon } from "@/shared/ui/icons";

type DOBRegister<T> = T extends {
  dateOfBirth: DateOfBirthValues;
}
  ? UseFormRegister<T>
  : never;

interface DOBFieldProps<
  T extends {
    dateOfBirth: DateOfBirthValues;
  },
> {
  register: DOBRegister<T>;
}

export const DateOfBirthInputs = <
  T extends {
    dateOfBirth: DateOfBirthValues;
  },
>({
  register,
}: DOBFieldProps<T>) => {
  return (
    <div className="mf-masked mf-listen grid grid-cols-3 gap-x-3">
      <Input.Root
        type="number"
        step={1}
        placeholder={t`MM`}
        autoComplete="bday-month"
        min={1}
        max={12}
        {...register("dateOfBirth.month", { setValueAs: Number })}
      >
        <Input.Slot>
          <CalendarIcon />
        </Input.Slot>
      </Input.Root>

      <Input.Root
        type="number"
        step={1}
        placeholder={t`DD`}
        autoComplete="bday-day"
        min={1}
        max={31}
        {...register("dateOfBirth.day", { setValueAs: Number })}
      />

      <Input.Root
        type="number"
        step={1}
        placeholder={t`YYYY`}
        autoComplete="bday-year"
        min={1900}
        {...register("dateOfBirth.year", { setValueAs: Number })}
      />
    </div>
  );
};
